var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-tabs",
        {
          attrs: { "background-color": "blue-grey lighten-5" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab", { key: "ad_unit" }, [_vm._v("Placement Groups")]),
          _c("v-tab", { key: "ad_placement" }, [_vm._v("Placements")]),
          _c("v-tab", { key: "ad_refill" }, [_vm._v("Energy Refill")]),
        ],
        1
      ),
      _c(
        "v-tabs-items",
        {
          staticClass: "mt-4",
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab-item", { key: "ad_unit" }, [_c("r-ad-unit-page")], 1),
          _c(
            "v-tab-item",
            { key: "ad_placement" },
            [_c("r-ad-placement-page")],
            1
          ),
          _c("v-tab-item", { key: "ad_refill" }, [_c("r-ad-refill-page")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }